/**
 * Category tab ordering — PURE, shared by the customer app (the real tabs) and
 * the admin panel (the "Category order" editor) so both always agree.
 *
 * `categories` is the list the sync publishes (app_config/global.categories,
 * alphabetical); `order` is the admin's saved app_config/global.categoryOrder,
 * which the sync never touches.
 */
/**
 * Effective tab order: entries of `order` that still exist in `categories`, in
 * that order, then every category the admin hasn't placed yet (e.g. a new tab
 * just added to the spreadsheet), alphabetically. No saved order ⇒ the
 * published list unchanged (the legacy alphabetical behavior).
 */
export function orderCategories(categories, order) {
    if (!order || order.length === 0)
        return categories.slice();
    const available = new Set(categories);
    const placed = new Set();
    const out = [];
    for (const name of order) {
        if (available.has(name) && !placed.has(name)) {
            placed.add(name);
            out.push(name);
        }
    }
    const rest = categories
        .filter((c, i) => !placed.has(c) && categories.indexOf(c) === i)
        .sort((a, b) => a.localeCompare(b));
    return out.concat(rest);
}
//# sourceMappingURL=categories.js.map